<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >

        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            v-if="permission.JOINS_SALESCLOUD_MESSAGETIPMODULE"
            @click.stop="handleAdd()"
          >新增</el-button>
          <el-button
            type="warning"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALESCLOUD_MESSAGETIPMODULE"
            @click.stop="handleDel('DELETE_OPTION','逻辑删除')"
          >删除</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALESCLOUD_MESSAGETIPMODULE"
            @click.stop="handleDel('DELETE_OPTION','物理删除')"
          >物理删除</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALESCLOUD_MESSAGETIPMODULE && scope.row.status != 'NORMAL'"
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="danger"
            icon="el-icon-close"
            size="small"
            plain
            @click.stop="handleDelete(scope.row,'逻辑删除')"
          >删除</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="channel"
        >
          <el-tag>{{scope.row.channel.channelName}}</el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="rule"
        >
          <el-tag v-if="null != scope.row.rule">{{scope.row.rule.ruleName}}</el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="templateTypeForm"
        >
          <el-select
            v-model="templateType"
            placeholder="请选择模板类型"
            @change="changeTemplate"
            value-key="value"
          >
            <el-option
              v-for="templateType in templateTypeList"
              :key="templateType.value"
              :label="templateType.label"
              :value="templateType"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="ruleForm"
        >
          <el-select
            v-model="rule"
            placeholder="请选择短信验证码规则"
            value-key="ruleFlag"
          >
            <el-option
              v-for="rule in ruleList"
              :key="rule.ruleFlag"
              :label="rule.ruleName"
              :value="rule"
            ></el-option>
          </el-select>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { messageTipModuleOption } from "@/const/salesCloud/messageTipModuleOption";
import {
  findTemplate,
  addTemplate,
  editTemplate,
  delTemplate
} from "@/api/salesCloud/messageTipModule";
import { findRuleAll } from "@/api/salesCloud/rule";
// import { findChannelAll } from "@/api/sms/channel";
import { findByLabel, resolveUrlPath, setUrlPath } from "@/util/util";

import { DIC } from "@/const/dic";
export default {
  name: "messageTipModule",
  components: {},
  data() {
    return {
      tableOption: messageTipModuleOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      templateType: {},
      templateTypeList: DIC.SMS_TEMPLATE_TYPE,
      ruleList: [],
      channel: {},
      rule: {}
    };
  },
  created() {
    this.handleList();
    findRuleAll().then(res => {
      let data = JSON.parse(res.data);
      this.ruleList = data.rows;
    });
    // findChannelAll().then((res) => {
    //     let data = JSON.parse(res.data);
    //     this.channelList = data.rows
    // })
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    changeTemplate() {
      if (this.templateType.value === "ALI_VERIFY_CODE") {
        messageTipModuleOption.column[7].editVisdiplay = true;
        messageTipModuleOption.column[7].addVisdiplay = true;
      } else {
        messageTipModuleOption.column[7].editVisdiplay = false;
        messageTipModuleOption.column[7].addVisdiplay = false;
      }
    },
    clean() {
      this.templateType = {};
      messageTipModuleOption.column[7].editVisdiplay = false;
      messageTipModuleOption.column[7].addVisdiplay = false;
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      params.moduleType = "CUSTOMER";
      findTemplate(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      params.moduleType = "CUSTOMER";
      findTemplate(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.moduleType = "CUSTOMER";
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.createTimeStart = params.startDate_endDate[0];
        params.createTimeEnd = params.startDate_endDate[1];
      } else {
        params.createTimeStart = "";
        params.createTimeEnd = "";
      }
      findTemplate(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      params.moduleType = "CUSTOMER";
      findTemplate(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      let obj = {
        label: "新增消息提醒模板",
        value: "messageTipModule/add"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label)
      });
      // this.clean();
      // this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.clean();
      this.rule.ruleFlag = row.ruleFlag;
      this.channel.id = row.channelId;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      params.moduleType = "CUSTOMER";
      findTemplate(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });

      this.rule = {};
      this.channel = {};
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.channelId = this.channel.id;
      row.ruleFlag = this.rule.ruleFlag;
      row.templateType = this.templateType.value;
      row.moduleType = "CUSTOMER";
      addTemplate(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    handleDelete(row, label) {
      console.log(row, label);
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let ids = new Array();
        ids.push(row.id);
        delTemplate(findByLabel(DIC.DELETE_OPTION, label), ids)
          .then(response => {
            if (response.code == "200") {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              });
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            });
          });
      });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delTemplate(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.channelId = this.channel.id;
      row.ruleFlag = this.rule.ruleFlag;
      editTemplate(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
